/** Build-time environment configuration — sandbox (internal testing). */
export const environment = {
  production: false,
};
